// import {
//   communityTabsLinking,
//   communityStackLinking,
// } from 'src/modules/community/communityLinking';
import { adminStackLinking, adminTabsLinking } from 'src/modules/admin/adminLinking';
import { examPreparationStackLinking, examPreparationTabsLinking, } from 'src/modules/exam-preparation/examPreparationLinking';
import { notificationStackLinking, notificationTabsLinking, } from 'src/modules/notification/notificationLinking';
import { reviewPipelineStackLinking } from 'src/modules/review-pipeline/reviewPipelineLinking';
import { stcTabsLinking } from 'src/modules/support-the-creators/stcLinking';
import { userStackLinking, userTabsLinking } from 'src/modules/user/userLinking';
import { getSeoPathFromState, getSeoStateFromPath, } from 'src/utils/seo/cleanNavigationStateForSeo';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
import { FallbackRouteName } from '../config';
import { DLPrefix } from './constants';
import { mergePathConfig } from './utils';
const linkingConfig = {
    initialRouteName: 'Tabs',
    screens: {
        Tabs: {
            screens: {
                // ...communityTabsLinking.screens,
                ...userTabsLinking.screens,
                ...notificationTabsLinking.screens,
                ...examPreparationTabsLinking.screens,
                ...stcTabsLinking.screens,
                ...adminTabsLinking.screens,
                [FallbackRouteName]: {
                    path: '*',
                    ...mergePathConfig([], ['tabID', 'examLevelID']),
                },
            },
        },
        // ...communityStackLinking.screens,
        ...examPreparationStackLinking.screens,
        ...userStackLinking.screens,
        ...notificationStackLinking.screens,
        ...reviewPipelineStackLinking.screens,
        ...adminStackLinking.screens,
    },
};
const linking = {
    prefixes: [
        DLPrefix,
        'https://app.marinesamraj.com',
        'https://marinesamraj.page.link',
    ],
    config: linkingConfig,
    ...(isSeoCrawler && {
        getPathFromState: state => getSeoPathFromState(state, linkingConfig),
        getStateFromPath: path => getSeoStateFromPath(path, linkingConfig),
    }),
};
export default linking;
